/* Claim flow (sections/ovl-claim.liquid). Sequential numbered steps like /pages/shop:
   answer a step, it collapses to "answer  Change" and the next one opens. The footer
   button reads Next while a step is open and Checkout once every step is answered. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ovl-claim]');
  if (!root) return;
  var cfgEl = root.querySelector('[data-ovl-claim-config]');
  if (!cfgEl) return; // closed state renders no config
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var steps = Array.prototype.slice.call(root.querySelectorAll('[data-ovl-step]'));
  var state = { plan: 'annual', size: null, answers: {} };
  var nextBtn = root.querySelector('[data-ovl-next]');
  var nextLabel = root.querySelector('[data-ovl-next-label]');
  var busy = false;

  /* ---------- money ---------- */
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = cfg.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.')).replace(/<[^>]+>/g, '');
  }
  function perPayment(cents) { return money(cents / (cfg.installments || 4)); }
  function annualSelected() { return state.plan === 'annual'; }
  function potAllowed() { return !cfg.plans[state.plan] || !cfg.plans[state.plan].sellingPlan; }

  /* ---------- step helpers ---------- */
  function kind(el) { return el.getAttribute('data-ovl-kind'); }
  function stepId(el) { return el.getAttribute('data-ovl-step'); }
  function upsellData(el) {
    var ann = annualSelected() && el.getAttribute('data-variant-annual');
    var variant = ann ? el.getAttribute('data-variant-annual') : el.getAttribute('data-variant');
    var price = parseInt(ann ? el.getAttribute('data-price-annual') : el.getAttribute('data-price'), 10) || 0;
    var available = (ann ? el.getAttribute('data-available-annual') : el.getAttribute('data-available')) === 'true';
    return { key: el.getAttribute('data-key'), title: el.getAttribute('data-title'), variant: variant, price: price, available: available && !!variant };
  }
  function visible(el) {
    if (kind(el) !== 'upsell') return true;
    return upsellData(el).available;
  }
  function answered(el) { return state.answers[stepId(el)] !== undefined; }
  function doneLabelFor(el) {
    var a = state.answers[stepId(el)];
    var k = kind(el);
    if (k === 'plan') return (cfg.plans[state.plan] || cfg.plans.annual).title;
    if (k === 'size') return (cfg.shirtProperty || 'T-Shirt size') + ': ' + a;
    if (a !== 'yes') return cfg.labels.no || 'Skipped';
    var t = el.getAttribute('data-title') || '';
    return (cfg.labels.yes || 'Added') + (t ? ': ' + t : '');
  }

  function refreshUpsellPrices() {
    steps.forEach(function (el) {
      if (kind(el) !== 'upsell') return;
      var d = upsellData(el);
      var p = el.querySelector('[data-ovl-upsell-price]');
      var per = el.querySelector('[data-ovl-upsell-per]');
      var pot = el.querySelector('[data-ovl-upsell-pot]');
      if (p) p.textContent = money(d.price);
      if (per) per.textContent = '+' + perPayment(d.price);
      if (pot) pot.hidden = !potAllowed();
      el.style.display = d.available ? '' : 'none';
    });
  }

  function render() {
    var active = null;
    steps.forEach(function (el) {
      if (!visible(el)) { el.classList.remove('is-active', 'is-done'); return; }
      var isDone = answered(el);
      el.classList.toggle('is-done', isDone);
      var lbl = el.querySelector('[data-ovl-done-label]');
      if (lbl && isDone) lbl.textContent = doneLabelFor(el);
      if (!active && !isDone) active = el;
    });
    steps.forEach(function (el) { el.classList.toggle('is-active', el === active); });
    var allDone = !active;
    if (nextBtn) {
      if (allDone) {
        nextBtn.disabled = false;
        if (nextLabel) nextLabel.textContent = cfg.labels.checkout || 'Checkout';
      } else {
        nextBtn.disabled = !active.querySelector('.tc__pill.is-selected');
        if (nextLabel) nextLabel.textContent = cfg.labels.next || 'Next';
      }
    }
    renderSummary(allDone);
    renderTotals();
  }

  function advanceFrom(el) {
    var a = el.querySelector('.tc__pill.is-selected');
    if (!a) return;
    var k = kind(el);
    if (k === 'plan') state.answers[stepId(el)] = state.plan;
    else if (k === 'size') { state.size = a.getAttribute('data-value'); state.answers[stepId(el)] = state.size; }
    else state.answers[stepId(el)] = a.getAttribute('data-value');
    render();
    scrollToActive();
  }
  function scrollToActive() {
    var active = root.querySelector('.tc__step.is-active') || root.querySelector('[data-ovl-next]');
    if (!active) return;
    var top = active.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* ---------- events ---------- */
  steps.forEach(function (el) {
    Array.prototype.forEach.call(el.querySelectorAll('[data-ovl-plan]'), function (tile) {
      var pick = function () {
        state.plan = tile.getAttribute('data-ovl-plan');
        Array.prototype.forEach.call(el.querySelectorAll('[data-ovl-plan]'), function (t) { t.classList.toggle('is-selected', t === tile); });
        refreshUpsellPrices();
        render();
      };
      tile.addEventListener('click', pick);
      tile.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });
    Array.prototype.forEach.call(el.querySelectorAll('.tc__pill'), function (pill) {
      pill.addEventListener('click', function () {
        Array.prototype.forEach.call(el.querySelectorAll('.tc__pill'), function (p) { p.classList.toggle('is-selected', p === pill); });
        advanceFrom(el);
      });
    });
    var change = el.querySelector('[data-ovl-change]');
    if (change) change.addEventListener('click', function () {
      var idx = steps.indexOf(el);
      steps.forEach(function (s, i) { if (i >= idx) delete state.answers[stepId(s)]; });
      render();
      scrollToActive();
    });
  });

  /* ---------- order ---------- */
  function orderLines() {
    var plan = cfg.plans[state.plan] || cfg.plans.annual;
    var lines = [];
    var props = {};
    if (cfg.needSize !== false) props[cfg.shirtProperty || 'T-Shirt size'] = state.size || '';
    if (cfg.mode === 'upgrade') props._Upgrade = 'existing subscriber';
    lines.push({ id: plan.variant, quantity: 1, selling_plan: plan.sellingPlan || null, properties: props, title: plan.title, price: plan.price });
    if (plan.maid && plan.maid.variant) lines.push({ id: plan.maid.variant, quantity: 1, selling_plan: null, properties: { _Overlord: 'free Maid Set' }, title: plan.maid.title, price: plan.maid.price, free: true });
    steps.forEach(function (el) {
      if (!visible(el) || state.answers[stepId(el)] !== 'yes') return;
      if (kind(el) === 'upsell') {
        var d = upsellData(el);
        lines.push({ id: d.variant, quantity: 1, selling_plan: null, properties: { _Overlord: 'checkout offer ' + (d.key || '') }, title: d.title, price: d.price });
      } else if (kind(el) === 'addon') {
        var price = parseInt(el.getAttribute('data-price'), 10) || 0;
        lines.push({ id: el.getAttribute('data-variant'), quantity: 1, selling_plan: null, properties: { _Overlord: 'add-on' }, title: el.getAttribute('data-title'), price: price, free: price === 0 });
        if (el.getAttribute('data-bonus-variant')) lines.push({ id: el.getAttribute('data-bonus-variant'), quantity: 1, selling_plan: null, properties: { _Overlord: 'free with add-on' }, title: el.getAttribute('data-bonus-title'), price: 0, free: true });
      }
    });
    return lines;
  }
  function total() { return orderLines().reduce(function (t, l) { return t + l.price; }, 0); }
  function renderTotals() {
    var t = total();
    var el = root.querySelector('[data-ovl-total]');
    if (el) el.textContent = money(t);
    var per = root.querySelector('[data-ovl-total-per]');
    if (per) per.textContent = (cfg.installments || 4) + ' x ' + perPayment(t);
    var pot = root.querySelector('[data-ovl-total-pot]');
    if (pot) pot.hidden = !potAllowed();
  }
  function renderSummary(show) {
    var ul = root.querySelector('[data-ovl-summary]');
    if (!ul) return;
    ul.hidden = !show;
    if (!show) return;
    ul.innerHTML = '';
    var sizeKey = cfg.shirtProperty || 'T-Shirt size';
    orderLines().forEach(function (l) {
      var li = document.createElement('li');
      var left = document.createElement('span');
      left.textContent = l.title;
      if (l.properties && l.properties[sizeKey]) {
        var small = document.createElement('small');
        small.textContent = sizeKey + ': ' + l.properties[sizeKey];
        left.appendChild(small);
      }
      var right = document.createElement('span');
      right.textContent = l.free ? 'FREE' : money(l.price);
      if (l.free) right.className = 'is-free';
      li.appendChild(left); li.appendChild(right);
      ul.appendChild(li);
    });
  }

  /* ---------- checkout ---------- */
  function closedNow() {
    if (!cfg.closesAt) return false;
    var end = Date.parse(cfg.closesAt);
    return !isNaN(end) && Date.now() > end;
  }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body || {}) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function fallbackURL(lines) {
    var base = (cfg.fallbackBase || '') + '/cart/clear?return_to=/cart/add?';
    lines.forEach(function (l) {
      base += 'items[][id]=' + l.id;
      if (l.selling_plan) base += '%26items[][selling_plan]=' + l.selling_plan;
      base += '%26items[][quantity]=1%26';
    });
    return base + 'return_to=/checkout';
  }
  function checkout() {
    if (busy) return;
    if (closedNow()) { window.location.reload(); return; }
    var lines = orderLines();
    if (!lines.length) return;
    busy = true;
    var spinner = root.querySelector('[data-ovl-spinner]');
    var err = root.querySelector('[data-ovl-checkout-error]');
    if (err) err.hidden = true;
    if (spinner) spinner.hidden = false;
    lines.forEach(function (l) {
      if (typeof fbq === 'function') {
        try { fbq('track', 'AddToCart', { content_ids: [String(l.id)], content_type: 'product', contents: [{ id: String(l.id), quantity: 1 }], value: l.price / 100, currency: cfg.currency || 'USD' }); } catch (e) {}
      }
    });
    var items = lines.map(function (l) {
      var it = { id: parseInt(l.id, 10), quantity: 1, properties: l.properties || {} };
      if (l.selling_plan) it.selling_plan = parseInt(l.selling_plan, 10);
      return it;
    });
    postJSON('/cart/clear.js')
      .then(function () { return postJSON('/cart/add.js', { items: items }); })
      .then(function () { return postJSON('/cart/update.js', { attributes: cfg.attributes || {} }); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { window.location.href = fallbackURL(lines); });
  }

  if (nextBtn) nextBtn.addEventListener('click', function () {
    var active = root.querySelector('.tc__step.is-active');
    if (active) { advanceFrom(active); return; }
    checkout();
  });

  refreshUpsellPrices();
  render();
})();
